"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeLabel = exports.fontWeightMap = void 0;
exports.fontWeightMap = {
    100: 'Thin',
    200: 'ExtraLight',
    300: 'Light',
    400: 'Regular',
    500: 'Medium',
    600: 'SemiBold',
    700: 'Bold',
    800: 'ExtraBold',
    900: 'Heavy',
};
exports.localeLabel = {
    arabic: 'Arabic',
    bengali: 'Bengali',
    chinese: '中国',
    cyrillic: 'кириллица',
    devanagari: 'Devanagari',
    greek: 'ελληνικά',
    gujarati: 'Gujarati',
    gurmukhi: 'Gurmukhi',
    hebrew: 'עברי',
    kannada: 'Kannada',
    khmer: 'Khmer',
    korean: '한국의',
    japanese: '日本の',
    'latin-ext': 'Latin Ext',
    malayalam: 'Malayalam',
    myanmar: 'Myanmar',
    oriya: 'Oriya',
    sinhala: 'Sinhala',
    tamil: 'Tamil',
    telugu: 'Telugu',
    thai: 'Thai',
    vietnamese: 'Vietnamese',
};
//# sourceMappingURL=FontFamily.config.js.map